<template>
  <!-- 任务列表  -->
  <div class="Materialtoupload">
    <div class="box">
      <div class="tbox-top">
        <h4 class="scsc">任务列表</h4>
      </div>
      <el-empty v-if="tepage.total == 0" description="暂未接取任务"></el-empty>
      <ul style="min-height: 750px">
        <li
          class="change"
          v-for="item in notice"
          :key="item.id"
          @click="Jumpfordetails(item.task.id)"
        >
          <div class="chaP" align="left">{{ item.task.name }}</div>
          <div class="dateof">
            {{ item.task.taskfbdate }}
          </div>
          <div class="an" style="margin-left: 50px">
            <el-button
              type="text"
              @click.stop="GiveUp(item.id)"
              :disabled="item.status == '已提交'"
              >放弃</el-button
            >
            <el-button type="text" @click.stop="Writing(item.task.id)"
              >撰写</el-button
            >
          </div>
        </li>
      </ul>

      <el-pagination
        class="paging"
        background
        prev-text="上一页"
        next-text="下一页"
        @current-change="handleCurrentChangess"
        :page-size="tepage.rows"
        layout="prev, pager, next"
        :total="tepage.total"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import { seltaskuser, deltaskuser, selknow } from "../../../api/patient";
export default {
  data() {
    return {
      tepage: {
        page: 1,
        rows: 10,
        total: 100,
      },
      notice: [],
    };
  },
  created() {
    this.selmaterialis();
  },
  methods: {
    // 撰写任务
    Writing(item) {
      this.$router.push(`/UploadPopular/${item}`);
    },
    //放弃任务
    GiveUp(item) {
      this.$confirm("此操作将永久删除该信息, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          var data = new FormData();
          data.append("id", item);
          deltaskuser(data).then((res) => {
            if (res.code == "OK") {
              this.selmaterialis();
              this.$message({
                type: "success",
                message: "放弃成功!",
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消放弃",
          });
        });
    },
    // 跳转到详情页
    Jumpfordetails(item) {
      this.$router.push(`/Informdetails/${item}`);
      // console.log(this.activeIndexs)
      this.$store.commit("zxxixvt", "任务发布");
    },
    // 列表
    selmaterialis() {
      var data = new FormData();
      data.append("page", this.tepage.page);
      data.append("rows", this.tepage.rows);
      // data.append("userid", this.$store.state.user.id);
      data.append("phone", this.$store.state.user.phone);
      seltaskuser(data).then((res) => {
        console.log(res);
        this.notice = res.records;
        this.tepage.total = res.totalCount;
        this.notice.map((item) => {
          this.selmater(item.tid);
        });
      });
    },
    handleCurrentChangess(val) {
      this.tepage.page = val;
      this.selmaterialis();
    },
  },
  beforeDestroy() {
    // this.$store.commit('Stateofsss', 1)
  },
};
</script>
<style lang="scss" scoped>
.Materialtoupload {
  .box {
    .tbox-top {
      display: flex;
      margin-bottom: 15px;
      .scsc {
        font-size: 16px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #333333;
        line-height: 40px;
        margin-right: 26px;
      }
      h2 {
        line-height: 40px;
        //   margin-right: 16px;
      }

      .el-select {
        line-height: 40px;
        width: 100px;
        ::v-deep .el-input__inner {
          border: 1px solid #4ccaff;
          height: 30px;
        }
      }
    }
  }
}
ul {
  .change:hover {
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #4ccaff;
    // margin-top: 20px;

    .dateof {
      color: #4ccaff;
    }
    p {
      color: #4ccaff;
    }
  }

  // margin-top: 45px;
  li {
    line-height: 36px;

    // position: relative;
    cursor: pointer;
    display: flex;
    // margin-bottom: 20px;

    .dateof {
      margin-left: 25px;
      font-size: 16px;
      font-family: SourceHanSansCN-Regular;
      font-weight: 400;
      color: #333333;
      margin-right: 19px;
      white-space: nowrap;
    }
    img {
      width: 19px;
      height: 19px;
      margin-right: 18px;
      // z-index:10
    }
    .chaP {
      // width: 100px;
      font-size: 16px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #333333;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      width: 480px;
    }
    .chaP:hover {
      color: #4ccaff;
    }
  }

  .dashed {
    position: relative;
    left: 10px;
    top: -10px;
    height: 40px;
    border: 1px dashed #bfbfbf;
  }
}

// 适配手机端
@media (max-width: 768px) {
  ul {
    .change:hover {
      font-size: 16px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #4ccaff;
      // margin-top: 20px;

      .dateof {
        color: #4ccaff;
      }
      p {
        color: #4ccaff;
      }
    }

    // margin-top: 45px;
    li {
      line-height: 36px;

      // position: relative;
      cursor: pointer;
      display: flex;
      // margin-bottom: 20px;

      .dateof {
        display: none;
      }
      img {
        width: 19px;
        height: 19px;
        margin-right: 18px;
        // z-index:10
      }
      .chaP {
        // width: 100px;
        font-size: 16px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #333333;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        width: 480px;
      }
      .chaP:hover {
        color: #4ccaff;
      }
    }
    .an {
      width: 35vw !important;
    }
    .dashed {
      position: relative;
      left: 10px;
      top: -10px;
      height: 40px;
      border: 1px dashed #bfbfbf;
    }
  }
}
</style>
